import { appRoutes } from './appRoutes';

export const SNOWFLAKE_ALLOWED_ROUTES = [
  appRoutes.getStarted.route,
  appRoutes.agenticLayer.route,
  appRoutes.environments.route,
  appRoutes.settings.route,
] as const;

export const isSnowflakeAllowedRoute = (pathname: string): boolean => {
  return SNOWFLAKE_ALLOWED_ROUTES.some((route) => pathname.includes(route));
};
